import React, { createContext, useContext, useState, useEffect } from "react";
import api from "../../utils/api";

const AuthContext = createContext();
export const useAuth = () => useContext(AuthContext);
export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [role, setRole] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const storedToken = localStorage.getItem("auth_token");
    const storedUser = localStorage.getItem("auth_user");
    const storedRole = localStorage.getItem("auth_role");

    if (storedToken && storedUser && storedRole) {
      const parsedUser = JSON.parse(storedUser);
      setToken(storedToken);
      setUser(parsedUser);
      setRole(storedRole);
      api.defaults.headers.common["Authorization"] = `Bearer ${storedToken}`;
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    try {
      const response = await api.post("/auth/login", { email, password });
      const { user: apiUser, token: apiToken } = response.data.data;

      localStorage.setItem("auth_token", apiToken);
      localStorage.setItem("auth_user", JSON.stringify(apiUser));
      localStorage.setItem("auth_role", apiUser.roles[0]);

      setToken(apiToken);
      setUser(apiUser);
      setRole(apiUser.roles[0]);
      api.defaults.headers.common["Authorization"] = `Bearer ${apiToken}`;

      return { success: true };
    } catch (error) {
      return {
        success: false,
        message: error.response?.data?.message || "Login failed",
      };
    }
  };

  const logout = () => {
    localStorage.removeItem("auth_token");
    localStorage.removeItem("auth_user");
    localStorage.removeItem("auth_role");
    setToken(null);
    setUser(null);
    setRole(null);
    delete api.defaults.headers.common["Authorization"];
  };

  const value = {
    user,
    token,
    role,
    login,
    logout,
    isAuthenticated: !!token,
    loading,
    userRoles: user?.roles || [],
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};